import React from "react";
import { WHATSAPP_LINK } from "../../mock";

const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label="Fale no WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#22c55e] animate-ping opacity-40" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-xl shadow-green-500/40 transition-transform group-hover:scale-110">
        <svg
          viewBox="0 0 32 32"
          className="w-8 h-8 md:w-9 md:h-9 fill-white"
          aria-hidden="true"
        >
          <path d="M16.004 0h-.008C7.174 0 .002 7.173.002 16c0 3.5 1.128 6.746 3.046 9.38L1.05 31.49l6.33-2.025A15.9 15.9 0 0016.004 32C24.83 32 32 24.826 32 16S24.83 0 16.004 0zm9.31 22.59c-.386 1.09-1.92 1.994-3.143 2.258-.836.178-1.928.32-5.604-1.203-4.703-1.95-7.73-6.73-7.966-7.04-.226-.31-1.9-2.53-1.9-4.826 0-2.296 1.173-3.425 1.588-3.89.34-.386.9-.56 1.44-.56.175 0 .332.008.474.015.414.018.622.043.896.698.34.82 1.17 2.838 1.27 3.046.1.207.17.45.034.76-.128.31-.235.447-.44.688-.207.24-.403.425-.61.683-.188.223-.4.464-.172.86.228.388 1.015 1.672 2.18 2.71 1.5 1.337 2.737 1.75 3.173 1.933.323.135.71.103.95-.155.303-.33.676-.878 1.056-1.418.27-.388.61-.436.967-.302.364.128 2.3 1.085 2.695 1.28.394.198.654.293.75.457.095.164.095.95-.29 2.04z" />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppButton;
